import React from 'react'
import styled from 'styled-components'
import Modal from 'components/atoms/Modal'

const AttachTemplateInfoModal = ({
  open,
  onClose,
  onSubmit,
  templateName
}) => {
  return (
    <Modal
      open={open}
      title={templateName ? `Before attaching “${templateName}”` : 'Before attaching'}
      onClose={onClose}
      onCancel={onClose}
      onSubmit={onSubmit}
      withCancel
      withSubmit
      submitButtonText='Attach template'
      cancelButtonText='Back'
    >
      <Content>
        <Lead>
          After you attach this checklist, you will be able to add upload rules
          per file type.
        </Lead>
        <Example>
          For example, for drawings you can define separate rule combinations by
          tags and assign who uploads them for the whole Building Passport or
          per unit.
        </Example>
        <Hint>
          You can configure these rules later from the checklist item Settings.
        </Hint>
      </Content>
    </Modal>
  )
}

export default AttachTemplateInfoModal

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 620px;
`

const Lead = styled.p`
  margin: 0;
  font-size: 15px;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.haiti};
  font-weight: 600;
`

const Example = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 1.6;
  color: ${({ theme }) => theme.colors.haiti};
`

const Hint = styled.p`
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.haiti};
`
